import { CommonModule } from "@angular/common"
import { ChangeDetectionStrategy, Component, forwardRef, Injector, OnInit } from "@angular/core"
import { NG_VALUE_ACCESSOR, NgControl } from "@angular/forms"
import { CorpControlCommonComponent } from "../common/corp-control-common/corp-control-common.component"

@Component({
    selector: 'corp-checkbox',
    standalone: true,
    templateUrl: 'corp-checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CorpCheckboxComponent),
            multi: true,
        },
    ],
})
export class CorpCheckboxComponent extends CorpControlCommonComponent implements OnInit {

    constructor(
        private injector: Injector) {
        super()
    }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null)
        this.setNgControl(ngControl)
    }

    protected override onInput(event: Event): void {

    const val = (event.target as HTMLInputElement).checked
    this.value = val
    this.onChange(val)
  }

    // override onBlur(event: Event): void {
    //     this.onTouched()
    // }

}